import { MapPin, Plus } from "lucide-react";
import { formatAddress } from "@/components/shop/AddressBook";

const KEYS = ["full_name", "address", "city", "zip", "province", "phone", "country"];
export const pickAddress = (a) => Object.fromEntries(KEYS.map((k) => [k, a[k] || ""]));

export const SavedAddressPicker = ({ addresses, selected, onSelect, onNew }) => {
  if (!addresses.length) return null;
  return (
    <div className="mt-4" data-testid="saved-addresses">
      <p className="text-sm text-stone-600">I tuoi indirizzi salvati</p>
      <div className="mt-2 flex flex-wrap gap-2">
        {addresses.map((a) => (
          <button type="button" key={a.id} onClick={() => onSelect(a)} data-testid={`saved-address-${a.id}`}
            className={`flex max-w-full items-start gap-2 rounded-xl border-2 px-3 py-2 text-left text-xs transition-colors ${selected === a.id ? "border-black bg-amber-500/15" : "border-black/10 bg-white hover:border-black/30"}`}>
            <MapPin className="mt-0.5 h-3.5 w-3.5 shrink-0 text-amber-600" />
            <span className="min-w-0"><b className="block truncate">{a.label || a.full_name}</b><span className="block truncate text-stone-600">{formatAddress(a)}</span></span>
          </button>
        ))}
        <button type="button" onClick={onNew} data-testid="saved-address-new"
          className={`flex items-center gap-1.5 rounded-xl border-2 border-dashed px-3 py-2 text-xs font-semibold ${selected === null ? "border-black" : "border-black/20"}`}><Plus className="h-3.5 w-3.5" />Nuovo indirizzo</button>
      </div>
    </div>
  );
};
